{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Käytössä",
      "DISABLED": "Pois käytöstä"
    },
    "CONFIGURE": "Määrittele",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Oletko varma että haluat poistaa?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Kyllä, poista",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Inbox",
      "EDIT": {
        "BUTTON_TEXT": "Muokkaa"
      },
      "DELETE": {
        "BUTTON_TEXT": "Poista"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Luo",
        "CANCEL": "Peruuta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "EDIT": {
      "TITLE": "Muokkaa: {name}",
      "FORM": {
        "SUBMIT": "Päivitä",
        "CANCEL": "Peruuta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integraatiokoukku päivitetty onnistuneesti",
        "ERROR_MESSAGE": "Yhteyden muodostaminen palvelimeen ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Yhdistä"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Synkronoi sähköpostit ja verkkokeskustelut Daktela-tilillesi.",
      "RETINO": "Retino tuo järjestystä palautusten ja reklamaatioiden hallintaan.",
      "MAILSHIP": "Mailship on varasto- ja tilaustenkäsittelyjärjestelmä. Tarkista tilauksen tila, seuranta ja lähetystiedot.",
      "RAYNET": "Yhdistä Raynet CRM -tilisi päästäksesi asiakastietoihisi. Lisää yhteys Raynet-käyttäjätunnuksellasi ja API-tunnuksellasi."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Testaa yhteys",
      "SUCCESS": "Yhteys onnistui",
      "ERROR": "Yhteys epäonnistui. Tarkista kirjautumistietosi."
    }
  }
}
